import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Phone, Globe, Send, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", business: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Compila nome, email e messaggio.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/contact`, form);
      toast.success(res.data.message || "Richiesta inviata!");
      setForm({ name: "", email: "", business: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Ops, qualcosa è andato storto. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="assistenza" className="py-20 sm:py-28 bg-[#F9FAFB]" data-testid="contact-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Assistenza</span>
          <h1 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
            Hai bisogno di aiuto?
          </h1>
          <p className="mt-4 font-body text-base sm:text-lg text-ink leading-relaxed max-w-md">
            Per dubbi rapidi chiedi ad <b className="text-brand-deep">Asia</b>, l'assistente AI in basso a destra.
            Per problemi tecnici o sul tuo account, scrivici: il nostro team ti risponde al più presto.
          </p>

          <div className="mt-8 space-y-4">
            <a href="mailto:info@pushapp.it" data-testid="contact-email-link" className="flex items-center gap-3 group">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-light/30 text-brand"><Mail size={20} strokeWidth={2.5} /></span>
              <span className="font-body text-ink group-hover:text-brand transition-colors">info@pushapp.it</span>
            </a>
            <a href="https://mypushapp.it" target="_blank" rel="noreferrer" data-testid="contact-web-link" className="flex items-center gap-3 group">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-light/30 text-brand"><Globe size={20} strokeWidth={2.5} /></span>
              <span className="font-body text-ink group-hover:text-brand transition-colors">mypushapp.it</span>
            </a>
            <a href="https://wa.me/393923875279" target="_blank" rel="noreferrer" data-testid="contact-whatsapp-link" className="flex items-center gap-3 group">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-green/15 text-brand-green"><Phone size={20} strokeWidth={2.5} /></span>
              <span className="font-body text-ink group-hover:text-brand-green transition-colors">Scrivici su WhatsApp</span>
            </a>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="rounded-[2rem] bg-white border border-gray-100 shadow-xl shadow-brand/5 p-7 sm:p-9"
          data-testid="contact-form"
        >
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="font-body text-sm font-medium text-brand-deep">Nome e cognome *</label>
              <input data-testid="contact-input-name" value={form.name} onChange={update("name")} className="mt-1.5 w-full rounded-xl border border-gray-200 px-4 py-3 font-body text-ink outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition" placeholder="Mario Rossi" />
            </div>
            <div>
              <label className="font-body text-sm font-medium text-brand-deep">Email *</label>
              <input data-testid="contact-input-email" type="email" value={form.email} onChange={update("email")} className="mt-1.5 w-full rounded-xl border border-gray-200 px-4 py-3 font-body text-ink outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition" placeholder="mario@esempio.it" />
            </div>
            <div>
              <label className="font-body text-sm font-medium text-brand-deep">Attività</label>
              <input data-testid="contact-input-business" value={form.business} onChange={update("business")} className="mt-1.5 w-full rounded-xl border border-gray-200 px-4 py-3 font-body text-ink outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition" placeholder="Boutique, palestra..." />
            </div>
            <div>
              <label className="font-body text-sm font-medium text-brand-deep">Telefono</label>
              <input data-testid="contact-input-phone" value={form.phone} onChange={update("phone")} className="mt-1.5 w-full rounded-xl border border-gray-200 px-4 py-3 font-body text-ink outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition" placeholder="+39 ..." />
            </div>
          </div>
          <div className="mt-4">
            <label className="font-body text-sm font-medium text-brand-deep">Messaggio *</label>
            <textarea data-testid="contact-input-message" value={form.message} onChange={update("message")} rows={4} className="mt-1.5 w-full rounded-xl border border-gray-200 px-4 py-3 font-body text-ink outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition resize-none" placeholder="Descrivi il tuo dubbio o problema..." />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="contact-submit-button"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand px-8 py-4 font-body font-semibold text-white shadow-lg shadow-brand/30 transition-all duration-300 hover:bg-brand-hover hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:translate-y-0"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} strokeWidth={2.5} />}
            {loading ? "Invio in corso..." : "Invia richiesta"}
          </button>
        </form>
      </div>
    </section>
  );
};
